import { createContext, useCallback, useMemo, useState } from "react";
import { Api } from "../utils/api";

const ActivityContext = createContext()

export const ActivityProvider = ({ children }) => {

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    const createActivity = useCallback(async ({ roadmpStepsId, roadmapId }) => {
        setLoading(true)
        setError(null)
        try {
            console.log("Activity created:", { roadmpStepsId, roadmapId });
            const res = await Api.post("/activity/create-activity", { roadmpStepsId, roadmapId })
            return res.data
        } catch (error) {
            setError(error.response?.data?.message || error.message);
        } finally {
            setLoading(false)
        }
    }, [])

    const deleteActivity = useCallback(async ({ roadmpStepsId,roadmapId }) => {
        setLoading(true)
        setError(null)
        try {
            const res = await Api.post(`/activity/delete-activity`,{roadmpStepsId,roadmapId})
            return res.data
        } catch (error) {
            setError(error.response?.data?.message || error.message);
        } finally {
            setLoading(false)
        }
    }, [])

    const getActivityByUser = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            const res = await Api.get("/activity/get-user-activity")
            return res.data
        } catch (error) {
            setError(error.response?.data?.message || error.message);
        } finally {
            setLoading(false)
        }
    }, [])

    const value = useMemo(() => ({
        loading,
        error,
        createActivity,
        deleteActivity,
        getActivityByUser,
    }), [loading, error, createActivity, deleteActivity, getActivityByUser]);

   

    return (
        <ActivityContext.Provider
        value={value}
        >{children}</ActivityContext.Provider>
    )
}

    export default ActivityContext
